import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Circle.scss';

const propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
const defaultProps = {
    className: null,
};

const Circle = ({ children, className, ...props }) => {
    const classes = classnames({
        Circle: true,
        [className]: !!className,
    });
    return (
        <div className={classes} {...props}>
            {children}
        </div>
    );
};

Circle.propTypes = propTypes;
Circle.defaultProps = defaultProps;

export default Circle;
